export default "__VITE_ASSET__CIaUSjHp__"